import axios from 'axios'
import Immutable from 'immutee'

import { getApiUrl, hasPandora, cleanString } from '../utils/utils'

export const FETCH_DETAIL = 'buyer/detail/FETCH_DETAIL'
export const FETCH_DETAIL_FAILURE = 'buyer/detail/FETCH_DETAIL_FAILURE'

const initialState = {
  fetched: false,
  result: [],
  error: null,
  statusCode: null,
}

export default function reducer(state = initialState, action) {
  const immutable = Immutable(state)
  switch (action.type) {
    case FETCH_DETAIL:
      return immutable
        .set('result', action.payload)
        .set('requested', action.requested)
        .set('fetched', true)
        .set('statusCode', null)
        .done()

    case FETCH_DETAIL_FAILURE:
      return immutable
        .set('error', action.payload)
        .set('errorStatus', action.errorStatus)
        .set('requested', action.requested)
        .set('result', [])
        .set('fetched', false)
        .set('statusCode', action.statusCode || null)
        .done()

    default:
      return state
  }
}

const URL_SLUG_OPTIONS = {
  toLowerCase: 1,
  removeDots: 1,
  removeAccents: 1,
  removeSpecial: 1,
  slugify: 1,
}

function normalizeUrlSegment(value) {
  if (!value) return value
  let decoded = value
  try {
    decoded = decodeURIComponent(value)
  } catch (e) {
    // valor com % solto não é URI válida; usa o valor cru
  }
  return cleanString(decoded, URL_SLUG_OPTIONS)
}

export function createUrl(data) {
  const { vehicleType, idAnuncio, year } = data
  const brand = normalizeUrlSegment(data.brand)
  const model = normalizeUrlSegment(data.model)
  const version = normalizeUrlSegment(data.version)
  const doors = normalizeUrlSegment(data.doors)
  const cc = normalizeUrlSegment(data.cc)

  let url = `${getApiUrl()}detail/${vehicleType}/${idAnuncio}`
  if (brand && model && year) {
    if (vehicleType == 'car' && version && doors) {
      url = `${getApiUrl()}detail/${vehicleType}/${brand}/${model}/${version}/${doors}/${year}/${idAnuncio}`
    } else if (vehicleType == 'bike' && cc) {
      url = `${getApiUrl()}detail/${vehicleType}/${brand}/${model}/${cc}/${year}/${idAnuncio}`
    }
  }

  return url
}

export function fetchDetail(data) {
  const url = createUrl(data)
  const pandora = hasPandora()
  const requestConfig = {
    params: { pandora },
  }

  return dispatch => {
    return axios
      .get(url, requestConfig)
      .then(res => {
        dispatch({
          type: FETCH_DETAIL,
          payload: res.data,
          requested: data,
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_DETAIL_FAILURE,
          payload: err.stack,
          errorStatus: err.response?.status || null,
          requested: data,
          statusCode: err.response ? err.response.status : null,
        })
      })
  }
}
